import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutShortPayReport extends Layout {
    datasourceShortPay: DataSource;
    excludabletextboxAgents: ExcludableTextbox;
    excludabletextboxCustomer: ExcludableTextbox;
    excludabletextboxOpsUser: ExcludableTextbox;
    excludeableTextboxSalesperson: ExcludableTextbox;
    switchGroupBy: Switch;
    switchPagebreak: Switch;
    textboxCutoffBillDate: Textbox;
    textboxUserType: Textbox;
}
